export const endpoints = {
  searchExperienceTransfer: 'experienceTransfer/search',
  deleteExperienceTransfer: 'experienceTransfer',
  caseTypeOptions: 'experienceTransfer/caseType/all/options',
  operationOptions: 'experienceTransfer/operationaccess/operation/all/options'
};
